import React from "react";
import { Empty } from "antd";
import { ReactComponent as CustomIcon } from "../../assets/images/emptyTable.svg";
import styled from "styled-components";

const EmptyCustom = styled(Empty)`
  & .ant-empty-description {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: #818181;
  }
`;

const EmptyText = styled.span`
color: #818181;
text-align: center;
font-family: Inter;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px; 
@media screen and (max-width: 1024px) {
  font-size: 14px;
}
`;

const EmptyTable = ({ T }) => {
  return (
    <div className="pt-[50px]">
      <EmptyCustom
        image={<CustomIcon />}
        description={T("No records found.")}
      />
    </div>
  );
};

export const EmptyTable2 = ({ T, text = "You’ve got no opportunity token yet." }) => {
  return (
    <div className="pt-[20px] pb-[20px]">
      <EmptyText>{T(text)}</EmptyText>
    </div>
  );
};
export default EmptyTable;
